import React from 'react';
import classNames from 'classnames';
import useCallbackRef from 'hooks/useCallbackRef';
import useHeightAnimation from 'hooks/useHeightAnimation';
import { XOR } from 'types';
import useContentAnimation from './hooks/useContentAnimation';
import { AnimationDirection } from './utils';

import './CarouselContentAnimate.styles.scss';

type WithTranslation = {
  direction: AnimationDirection;
};

type WithoutTranslation = {
  withOpacity: true;
};

type CarouselContentAnimateProps = {
  className?: string;
} & XOR<WithTranslation, WithoutTranslation>;

const CarouselContentAnimate: React.FC<CarouselContentAnimateProps> = (
  props,
) => {
  const { children, className, direction, withOpacity = false } = props;
  const [container, containerRef] = useCallbackRef<HTMLDivElement>();
  const { displayChildren, animatedClasses, onTransitionEnd } =
    useContentAnimation({ children, direction, withOpacity });

  useHeightAnimation({
    element: container,
  });

  const classes = classNames(
    'carousel-content-animation--container',
    className,
  );

  const contentClasses = classNames(
    'carousel-content-animation',
    animatedClasses,
  );

  return (
    <div className={classes} ref={containerRef}>
      <div className={contentClasses} onTransitionEnd={onTransitionEnd}>
        {displayChildren}
      </div>
    </div>
  );
};

export default CarouselContentAnimate;
